import { InjectionToken } from '@angular/core';

import { BorrowStatsFacade } from './borrow-stats.facade';

export const BORROW_STATS_FACADE = new InjectionToken<BorrowStatsFacade>(
  'BORROW_STATS_FACADE'
);